import React from 'react'
import {Icon} from '@chakra-ui/react'

const FreeDeliveryIcon = (props) => {
    return (
        <Icon
            viewBox="0 0 20 20"
            width="20px"
            height="20px"
            aspectRatio="1/1"
            fill="none"
            aria-hidden="true"
            {...props}
        >
            <path
                d="M4.40896 1.99951H7.60882C8.6996 1.99951 9.24499 1.99951 9.62733 2.27729C9.75081 2.367 9.85939 2.47559 9.9491 2.59907C10.2269 2.9814 10.2269 3.52679 10.2269 4.61758V15.8171H1.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M10.2266 5.63647H12.6235C14.6678 5.63647 15.6899 5.63647 16.4324 6.14423C16.6729 6.30869 16.8873 6.50834 17.0685 6.7365C17.6279 7.44095 17.7007 8.46048 17.8463 10.4995L18.0259 13.0132C18.1088 14.1738 18.1502 14.7541 17.8763 15.1672C17.7881 15.3002 17.6786 15.4178 17.5523 15.5152C17.1598 15.8178 16.578 15.8178 15.4145 15.8178H10.2266V5.63647Z"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <circle
                cx="14.2263"
                cy="16.1814"
                r="1.8181"
                fill="currentColor"
                fillOpacity="0.12"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <circle
                cx="6.2263"
                cy="16.1814"
                r="1.8181"
                fill="currentColor"
                fillOpacity="0.12"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M17.499 10.7264L16.4809 10.7264C15.3901 10.7264 14.8447 10.7264 14.4624 10.4487C14.3389 10.3589 14.2303 10.2504 14.1406 10.1269C13.8628 9.74455 13.8628 9.19908 13.8628 8.10814C13.8628 6.80149 13.8628 5.63576 13.8628 5.63576"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.31836 10.7264L2.22768 10.7264"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                opacity="0.1"
                d="M16.0449 10.7264L10.9542 10.7264"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                opacity="0.1"
                d="M13.4268 8.1084L10.9541 8.1084"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                opacity="0.1"
                d="M17.79 13.3445L10.954 13.3445"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M7.31836 6.36292L3.68216 6.36291"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </Icon>
    )
}

export default FreeDeliveryIcon
